<template>
  <!-- Grafico de estados -->
  <div class="completo">
    <canvas ref="myCanvasPorcentaje"></canvas>
    <canvas
      class="canvas-labels"
      ref="myCanvasLabels"
    >
    </canvas>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment-timezone";
export default {
  props: {
    input: Object,
  },
  data() {
    return {
      diffTotal: 0,
      cajas: {},
      anchoTotal: 0,
      windowWidth: window.innerWidth,
      canvasWidth: 10,
      canvasHeight: 10,

      dataList: [], // Lista que se llenará con los datos generados
      timeDifferenceInSeconds: 0,
    };
  },
  computed: {
    ...mapState(["selectedItem", "pages", "selectedPage", "scadaDimensions"]),
    filtroAVigilar() {
      try {
        // console.log("LOS ITEMS", this.pages[this.selectedPage].item_list, this.input.filtroAsociado);
        const a = this.pages[this.selectedPage].item_list.find((item) => {
          return item.name === this.input.filtroAsociado.name;
        });

        // console.log("El elegido es", a);
        return a.customized.data;
      } catch (error) {
        return [];
      }
    },

    filtroAsociado() {
      try {
        //console.log("LOS ITEMS", this.pages[this.selectedPage].item_list, this.input.filtroAsociado);
        const a = this.pages[this.selectedPage].item_list.find((item) => {
          return item.name === this.input.filtroAsociado.name;
        });

        //console.log("El elegido es", a);
        return a.customized;
      } catch (error) {
        return {};
      }
    },

    idEjeX() {
      return this.input.customized.tipoEjeX;
    },
  },
  watch: {
    filtroAVigilar() {
      // this.dataList = this.generateData(3);
      this.dataList = JSON.parse(JSON.stringify(this.filtroAVigilar));
      try {
        this.dataList.map((l) => {
          l.color = this.generarColor(l.value);
          return l;
        });
        // this.timeDifferenceInSeconds = this.calculateTimeDifference(this.dataList);
        this.timeDifferenceInSeconds = this.diferenciaEntreFechaHorasEnSegundos(
          this.filtroAsociado.valorFechas.inicio,
          this.filtroAsociado.valorFechas.fin
        );
        this.updateCanvasSize(); // Llama a la función para ajustar el tamaño y redibujar
      } catch (error) {
        console.log(error);
      }
    },
    scadaDimensions: {
      handler() {
        this.updateCanvasSize();
      },
      deep: true,
    },
    "input.customized": {
      handler() {
        this.updateCanvasSize();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["getData"]),
    generarColor(marcha) {
      const elemento = this.input.customized.estados.filter((es) => es.valor == marcha);
      // console.log("elemento.length", elemento.length);
      if (elemento.length == 1) {
        return elemento[0].color;
      } else return "black";
    },
    updateCanvasSize() {
      try {
        if (this.input && this.input.customized && this.scadaDimensions) {
          this.canvasWidth = (this.input.customized.width / 100) * this.scadaDimensions.width;
          this.canvasHeight = (this.input.customized.height / 100) * this.scadaDimensions.height;
          // Accede al canvas y ajusta el tamaño
          const canvas = this.$refs.myCanvasPorcentaje;
          canvas.width = this.canvasWidth;
          canvas.height = this.canvasHeight;

          this.drawBox(); // Redibuja después de cambiar el tamaño
          this.drawLabels(); // Redibuja las etiquetas
        }
      } catch (error) {
        console.log(error);
      }
    },

    diferenciaEntreFechaHorasEnSegundos(dateStrA, dateStrB) {
      // Convierte las cadenas a objetos Moment
      const momentA = moment(dateStrA, "YYYY-MM-DD HH:mm:ss");
      const momentB = moment(dateStrB, "YYYY-MM-DD HH:mm:ss");

      // Calcula la diferencia en segundos
      return Math.abs(momentB.diff(momentA, "seconds"));
    },

    drawBox() {
      const scaleFactor = 2;
      if (this.dataList.length === 0) return;

      const canvas = this.$refs.myCanvasPorcentaje;
      if (canvas) {
        // Ajustar tamaño del canvas
        canvas.width = (this.canvasWidth / scaleFactor) * scaleFactor;
        canvas.height = (this.canvasHeight / scaleFactor) * scaleFactor;

        const context = canvas.getContext("2d");

        // Aplicar escala al contexto
        context.scale(scaleFactor, scaleFactor);
        context.clearRect(0, 0, canvas.width / scaleFactor, canvas.height / scaleFactor); // Limpiar el canvas antes de redibujar

        let lastValue = null; // Inicializa lastValue aquí
        let lastFecha = null;
        let lastColor = null;
        this.diffTotal = 0;
        let valueTimeMap = {}; // Mapa para almacenar el sumatorio de tiempos para cada valor
        for (let index = 0; index < this.dataList.length; index++) {
          const element = this.dataList[index];
          if (index === 0) {
            const lastFechaSinFormato = this.filtroAsociado.valorFechas.inicio;
            lastFecha = moment(lastFechaSinFormato, "YYYY-MM-DD HH:mm:ss").toISOString();

            // lastFecha = this.filtroAsociado.valorFechas.inicio;
            lastValue = element.value;
            lastColor = element.color;
          } else {
            // Calcular la diferencia en tiempo
            let diff = this.diferenciaEntreFechaHorasEnSegundos(lastFecha, element.read_at);
            let ultimaFecha = null;
            if (index === this.dataList.length - 1) {
              ultimaFecha = moment(this.filtroAsociado.valorFechas.fin, "YYYY-MM-DD HH:mm:ss").toISOString();
              diff = this.diferenciaEntreFechaHorasEnSegundos(lastFecha, ultimaFecha);
              // diff = this.diferenciaEntreFechaHorasEnSegundos(lastFecha, this.filtroAsociado.valorFechas.fin);
            }

            this.diffTotal += diff;

            const current_width = ((this.canvasWidth / scaleFactor) * diff) / this.timeDifferenceInSeconds;

            // Actualizar el mapa de tiempos
            if (lastValue in valueTimeMap) {
              valueTimeMap[lastValue].ancho += current_width;
              valueTimeMap[lastValue].diff += diff;
            } else {
              valueTimeMap[lastValue] = {
                ancho: current_width,
                color: lastColor,
                valor: lastValue,
                diff: diff,
              };
            }

            lastValue = element.value;
            lastColor = element.color;
            lastFecha = element.read_at;
          }
        }
        console.log("diff total", this.diffTotal);

        // Convertir el objeto en un array de objetos con ancho y color
        this.resultArray = Object.values(valueTimeMap);

        // Segundo bucle para dibujar los segmentos
        let posX = 0;

        // console.log("A PINTAR!!!!", this.resultArray);
        this.anchoTotal = 0;

        console.log("CAJAS PORCENTAJE", this.cajas);

        this.resultArray?.forEach(({ ancho, color }) => {
          // console.log(posX, 0, ancho, canvas.height / scaleFactor);
          context.fillStyle = color;
          context.fillRect(posX, 0, ancho, canvas.height / scaleFactor);
          posX += ancho; // Actualiza posX para el próximo segmento
        });
        this.anchoTotal = posX;
        console.log("ancho total", this.anchoTotal);
        // console.log("Sumatorio de tiempos por valor:", valueTimeMap);
      }
    },

    getText(marcha) {
      // console.log("temporal", this.input.customized.estados);
      const elemento = this.input.customized.estados.filter((es) => es.valor == marcha);
      // console.log("elemento.length", elemento.length);
      if (elemento.length == 1) {
        return elemento[0].nombre;
      } else return "black";
    },
    drawLabels() {
      const scaleFactor = 2;
      const canvasPorcentaje = this.$refs.myCanvasPorcentaje;
      const canvas = this.$refs.myCanvasLabels;

      // Ajustar tamaño del canvas
      canvas.width = canvasPorcentaje.width * scaleFactor;
      canvas.height = canvasPorcentaje.height * scaleFactor;

      // Aplicar escala al contexto del canvas
      const context = canvas.getContext("2d");
      context.save(); // Guardar el estado del contexto
      context.scale(scaleFactor, scaleFactor);

      // Limpiar el canvas antes de redibujar
      context.clearRect(0, 0, canvas.width / scaleFactor, canvas.height / scaleFactor);

      let x = 0; // Posición horizontal inicial
      const y = canvas.height / (2 * scaleFactor); // Posición vertical base para centrar texto con respecto al cuadrado
      const squareSize = canvas.width / (scaleFactor * 20); // Tamaño del cuadrado en función del ancho del canvas
      const textMargin = canvas.width / (scaleFactor * 50); // Margen entre el cuadrado y el texto
      const extraMargin = canvas.width / (scaleFactor * 30); // Margen adicional después del texto
      const fontSize = canvas.width / (scaleFactor * 65); // Tamaño de la fuente función del tamaño del canvas

      context.font = `${fontSize}px Arial`; // Configurar el tamaño de la fuente
      // const textHeight = fontSize; // La altura aproximada del texto puede ser igual al tamaño de la fuente

      for (let index = 0; index < this.resultArray?.length; index++) {
        const element = this.resultArray[index];

        console.log("element en porcentaje", element);

        // Determinar el texto correspondiente
        let text = this.getText(element.valor);

        const current_porcentaje = ((element.diff / this.diffTotal) * 100).toFixed(2);
        text += ` (${current_porcentaje}%)`;

        // Dibujar el cuadrado
        context.fillStyle = element.color;
        context.fillRect(x, y - squareSize / 2, squareSize, squareSize); // Centrar verticalmente

        // Medir el ancho del texto
        const textWidth = context.measureText(text).width;

        // Ajustar la posición vertical para centrar el texto con el cuadrado
        const textY = y; // Centrado vertical con el cuadrado

        // Dibujar el texto
        context.fillStyle = "#000"; // Color del texto
        context.textAlign = "left"; // Alineación del texto
        context.textBaseline = "middle"; // Baseline del texto

        context.fillText(text, x + squareSize + textMargin, textY); // Posición del texto centrada verticalmente

        // Actualizar la posición horizontal para el próximo elemento
        x += squareSize + textMargin + textWidth + extraMargin; // Ajustar según el tamaño del texto
      }

      context.restore(); // Restaurar el estado del contexto
    },
    generateUniformDateLabels(startDateStr, endDateStr, numLabels) {
      const startDate = moment(startDateStr, "YYYY-MM-DD HH:mm:ss");
      const endDate = moment(endDateStr, "YYYY-MM-DD HH:mm:ss");
      const totalDuration = endDate.diff(startDate, "seconds");

      const labels = [];
      for (let i = 0; i < numLabels; i++) {
        const currentMoment = startDate.clone().add((totalDuration / (numLabels - 1)) * i, "seconds");
        labels.push(currentMoment.toISOString()); // Usa toISOString para asegurar formato consistente
      }
      return labels;
    },

    drawRotatedText(context, text, x, y, angle) {
      context.save(); // Guarda el estado actual del contexto
      context.translate(x, y); // Mueve el origen de coordenadas
      context.rotate(angle); // Rota el contexto
      context.textAlign = "center"; // Alinea el texto al centro
      context.textBaseline = "middle"; // Alinea el texto verticalmente en el medio
      context.fillText(text, 0, 0); // Dibuja el texto
      context.restore(); // Restaura el estado original del contexto
    },

    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
      this.updateCanvasSize();
    },
  },
  mounted() {
    // this.dataList = this.generateData(3);
    // this.timeDifferenceInSeconds = this.calculateTimeDifference(this.dataList);

    // console.log(this.dataList);
    // console.log("timeDifferenceInSeconds", this.timeDifferenceInSeconds);

    // this.updateCanvasSize(); // Llama a la función para ajustar el tamaño y redibujar
    window.addEventListener("resize", this.updateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateWindowWidth);
  },
};
</script>

<style scoped>
.completo {
  height: 100%;
  width: 100%;
}

.canvas-data,
.canvas-labels {
  display: block;
  /* Asegura que cada canvas esté en su propia línea */
  width: 100%;
  /* Ajusta el ancho al 100% del contenedor */
}

.canvas-labels {
  margin-top: -30px;
  /* Añade un margen para separar los canvas */
  z-index: 2;
  /* Canvas de etiquetas por encima */
}
</style>
